<template>
  <section class="form-list">
    <el-form
      ref="form"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form"
      :rules="rules"
    >
      <el-form-item label="申请时间">{{ post.add_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="申请者">
        <v-avatar-nickname
          :value="post.admin_avatar"
          :nickname="post.admin_nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="申请门店">{{ post.store_name }}</el-form-item>

      <el-form-item label="申请原因">
        <span>{{ post.apply_remark || '' }}</span>
      </el-form-item>

      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="post.selfie"
          :nickname="post.student_name"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="post.student_id"
          :avatar-size="50"
        />
      </el-form-item>

      <el-form-item label="是否仅限新生办理">
        <span v-if="post.is_new" class="success-color">是</span>
        <span v-else class="danger-color">否</span>
      </el-form-item>
      <el-form-item label="课次券名称">{{ post.card_ticket_type_name }}</el-form-item>
      <el-form-item label="有效天数">
        <span class="success-color">{{ post.expire_days | toYuan }}</span> 天
      </el-form-item>
      <el-form-item label="有效次数">
        <span class="success-color">{{ post.expire_number | toYuan }}</span> 次
      </el-form-item>
      <el-form-item label="付款方式">
        <span v-if="post.actual_payment > 0">{{ findPaymentModeName(post.card_payment_mode_id) }}</span>
        <span v-else>
          <span v-if="post.card_id" class="success-color">办卡附赠</span>
          <span v-else class="success-color">免费赠送</span>
        </span>
      </el-form-item>

      <template v-if="post.card_payment_mode_id === paymentModes.youZan.value">
        <el-form-item label="有赞券码">{{ post.you_zan_number || '' }}</el-form-item>
        <el-form-item label="有赞核销金额">{{ post.you_zan_payment | toYuan }} 元</el-form-item>
      </template>
      <el-form-item label="课卡原价">
        <span class="danger-color">{{ post.price | toYuan }} </span>元
      </el-form-item>
      <el-form-item label="实际付款">
        <span class="success-color">{{ post.actual_payment | toYuan }}</span> 元
      </el-form-item>
      <el-form-item label="积分抵扣">
        <span class="success-color">{{ post.integral | toYuan }}</span> 元
      </el-form-item>
      <el-form-item label="付款凭证" prop="payment_remark">
        <v-img v-if="post.receipt" :value="post.receipt" class="cover"/>
        <span v-else class="info-color">无</span>
      </el-form-item>
      <el-form-item label="付款备注" prop="payment_remark">
        <span v-if="post.payment_remark">{{post.payment_remark}}</span>
        <span v-else class="info-color">无</span>
      </el-form-item>
      <el-form-item label="付款备注图片" prop="payment_remark">
        <v-img v-if="post.remark_file" :value="post.remark_file" class="cover"/>
        <span class="info-color" v-else>无</span>
      </el-form-item>
      <el-form-item label="审核状态">
        <span v-if="!isLoading && !isLoadingError" :class="`${applyState.tagType}-color`">{{ applyState.name }}</span>
      </el-form-item>

      <template v-if="!isLoading && !isLoadingError && applyState.timeLabel && (canViewReviewInfo)">
        <el-form-item :label="applyState.timeLabel">{{ post.update_time | timeToYmdHi }}</el-form-item>
        <el-form-item :label="applyState.personLabel">
          <v-avatar-nickname
            :value="post.admin_avatar_update"
            :nickname="post.admin_nickname_update"
            :is-center="false"
          />
        </el-form-item>
      </template>

      <el-form-item v-if="applyState.value === applyStates.rejected.value && (canViewReviewInfo)" label="驳回原因">
        <span class="danger-color">{{ post.review_remark || '' }}</span>
      </el-form-item>

      <el-form-item v-if="applyState.value === applyStates.passed.value && isAdministrator" label="审核备注">
        <span v-if="post.review_remark" class="danger-color">{{ post.review_remark }}</span>
        <span v-else class="info-color">未填写</span>
      </el-form-item>

      <template v-if="!isLoading && !isLoadingError && post.apply_state === applyStates.review.value">
        <template v-if="isAdministrator">
          <el-form-item label="审核结果">
            <el-radio v-model="isReject" :label="0" :disabled="isExamining">通过</el-radio>
            <el-radio v-model="isReject" :label="1" :disabled="isExamining">驳回</el-radio>
          </el-form-item>

          <el-form-item :label="isReject ? '驳回原因' : '审核备注'" prop="review_remark">
            <el-input
              class="clearable-word-limit-input"
              v-model="post.review_remark"
              maxlength="200"
              :placeholder="isReject ? '请输入驳回原因' : '请输入审核备注'"
              show-word-limit
              clearable
              :disabled="isExamining"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleExamine" :loading="isExamining">完成审核</el-button>
            <el-button @click="RouteConfig.cardTicketAddApplyList.back">返回</el-button>
          </el-form-item>
        </template>
        <el-form-item v-else>
          <el-button type="primary" @click="handleRevoke" :loading="isExamining">撤回</el-button>
          <el-button @click="RouteConfig.cardTicketAddApplyList.back">返回</el-button>
        </el-form-item>
      </template>
      <el-form-item v-else>
        <el-button @click="RouteConfig.cardTicketAddApplyList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update, destroy } from "@/api/card-ticket-add-apply";
import { store } from "@/api/card-ticket-add-record";
import weeks from "@/enums/weeks";
import { applyStates, findApplyState } from "@/enums/applyStates";
import { findPaymentModeName } from "@/enums/paymentModes";
import { paymentModes } from "@/enums/paymentModes";
import { mapGetters } from 'vuex';

export default {
  name: RouteConfig.cardTicketAddApplyDetail.name,
  data: () => ({
    RouteConfig,
    paymentModes,
    isLoading: false,
    isLoadingError: false,
    isExamining: false,
    isReject: 0,
    weeks: JSON.parse(JSON.stringify(weeks)),
    applyStates,
    post: {
      add_time: 0,
      update_time: 0,
      student_id: 0,
      student_name: '',
      card_ticket_type_name: '',
      selfie: '',
      card_payment_mode_name: '',
      expire_number: '',
      expire_days: '',
      card_payment_mode_id: '',
      you_zan_number: '',
      price: 0,
      actual_payment: '',
      you_zan_payment: '',
      integral: 0,
      payment_remark: '',
      receipt: '',
      remark_file: '',
      is_reviewing: 0,
      enabled_weeks: [],
      apply_state: applyStates.review.value,
      apply_remark: '',
      admin_avatar: '',
      admin_nickname: '',
      admin_avatar_update: '',
      admin_nickname_update: '',
      store_name: '',
      is_new: 0,
      review_remark: '',
      card_ticket_type_id: 0,
      store_id: 0,
    },
  }),
  computed: {
    rules() {
      return this.isReject
        ? { review_remark: [{ required: true, message: '请输入驳回原因', trigger: 'change' }] }
        : {};
    },
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.post.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
    applyState() {
      return findApplyState(this.post.apply_state)[0] || {};
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    findPaymentModeName,
    async show() {
      this.isLoadFailed = false;
      const { isError, data } = await show(this.id);
      if (isError || !data) return this.isLoadFailed = true;

      const { post } = this;
      let updateData = {};

      Object.keys(data).forEach(key => {
        if (key in post) updateData[key] = data[key];
      });
      Object.assign(post, updateData);
    },
    handleExamine() {
      if (this.isExamining) return;

      if (this.isReject) {
        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;
          this.isExamining = true;
          this.handleReject();
        });
      } else {
        this.isExamining = true;
        this.handlePass();
      }
    },
    async handlePass() {
      const { isError } = await store({ apply_id: this.id, review_remark: this.post.review_remark });
      this.isExamining = false;

      if (!isError) RouteConfig.cardTicketAddApplyList.push({ apply_state: applyStates.review.value });
    },
    async handleReject() {
      const { isError } = await update(
        this.id,
        { review_remark: this.post.review_remark, update_time: this.post.update_time },
      );
      this.isExamining = false;

      if (!isError) RouteConfig.cardTicketAddApplyList.push({ apply_state: applyStates.review.value });
    },
    async handleRevoke() {
      if (this.isExamining) return;

      this.isExamining = true;
      const { isError } = await destroy(this.id, { update_time: this.post.update_time });
      if (isError) return;

      RouteConfig.cardTicketAddApplyList.push({ apply_state: applyStates.revoked.value });
    },
  },
};
</script>
